// extracted by mini-css-extract-plugin
module.exports = {"post-details":"detailedPost_post-details__l1hCn","comments-list":"detailedPost_comments-list__234YF","lists":"detailedPost_lists__2i1KJ"};